import { render } from "./ProjectItem.vue?vue&type=template&id=7e84fdc2&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=7e84fdc2&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e84fdc2"]])

export default __exports__